export default __webpack_public_path__ + "static/media/prize-1-cn.372b6d85.webp";